import React, { useState, useEffect } from 'react';
import { changeStudentStatus as changeStudentStatusAPI, fetchStudentStatuses as fetchStudentStatusesAPI } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const ChangeStudentStatusModal = ({ student, onClose, onStatusChanged }) => {
    const [mainStatus, setMainStatus] = useState('');
    const [innerStatus, setInnerStatus] = useState('');
    const [studentStatuses, setStudentStatuses] = useState({});
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const statusesData = await fetchStudentStatusesAPI();
                setStudentStatuses(statusesData.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };

        fetchInitialData();
    }, []);

    useEffect(() => {
        if (student) {
            setMainStatus(student.status.mss_id);
            setInnerStatus(student.status.iss_id);
        }
    }, [student]);

    const handleStatusChangeSubmit = async (e) => {
        e.preventDefault();
        try {
            await changeStudentStatusAPI(student.id, mainStatus, innerStatus);
            onStatusChanged();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Change Student Status</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleStatusChangeSubmit}>
                    <div className="form-group">
                        <label>Main Status</label>
                        <select value={mainStatus} onChange={(e) => { setMainStatus(e.target.value); setInnerStatus(''); }}>
                            <option value="">Select Main Status</option>
                            {Object.entries(studentStatuses).map(([id, statuses]) => (
                                <option key={id} value={id}>{statuses[0]}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Inner Status</label>
                        <select value={innerStatus} onChange={(e) => setInnerStatus(e.target.value)} disabled={!mainStatus}>
                            <option value="">Select Inner Status</option>
                            {mainStatus && studentStatuses[mainStatus] &&
                                Object.entries(studentStatuses[mainStatus]).map(([id, name]) => {
                                    if (id !== "0") {
                                        return <option key={id} value={id}>{name}</option>
                                    }
                                    return null;
                                })
                            }
                        </select>
                    </div>
                    <div className="actions-centered">
                        <button type="button" onClick={onClose} className="cancel-button text-button">Cancel</button>
                        <button type="submit" className="submit-button text-button">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangeStudentStatusModal;
